var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 125,
    viewBox: "0 0 146 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_1849)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10_1849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1271 19H114.047C120.509 19 125.747 24.4132 125.747 31.0906V78.0305C125.747 84.708 120.509 90.1211 114.047 90.1211H56.9204L74.1271 19Z",
    fill: "#FAF9F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7587 32.4736H31.6009C25.1939 32.4736 20 37.8868 20 44.5642V91.5041C20 98.1817 25.1939 103.595 31.6009 103.595H71.1802L72.7673 96.9781H48.2858L63.7587 32.4736Z",
    fill: "#FAF9F6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10_1849",
    x: 1.29481,
    y: 4.03585,
    width: 144.314,
    height: 124.085,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.74104
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.3526
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10_1849"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10_1849",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_1849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 125,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarpLogo);
export default __webpack_public_path__ + "static/media/warp_logo.svg";
export { ForwardRef as ReactComponent };